// source: miraibaraiops/ops_common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage', null, global);
goog.exportSymbol('proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole', null, global);
goog.exportSymbol('proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl', null, global);
goog.exportSymbol('proto.com.kipp.miraibarai.grpc.ops.v1.operatorAcl', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.repeatedFields_, null);
};
goog.inherits(proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.displayName = 'proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.displayName = 'proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.toObject = function(includeInstance, msg) {
  var f, obj = {
accessibleRolesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
forAllOperators: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl;
  return proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAccessibleRoles(values[i]);
      }
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForAllOperators(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessibleRolesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getForAllOperators();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated OperationRole accessible_roles = 1;
 * @return {!Array<!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole>}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.getAccessibleRolesList = function() {
  return /** @type {!Array<!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole>} value
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.setAccessibleRolesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole} value
 * @param {number=} opt_index
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.addAccessibleRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.clearAccessibleRolesList = function() {
  return this.setAccessibleRolesList([]);
};


/**
 * optional bool is_public = 2;
 * @return {boolean}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool for_all_operators = 3;
 * @return {boolean}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.getForAllOperators = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.prototype.setForAllOperators = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
errorMessageJa: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage;
  return proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessageJa(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorMessageJa();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string error_message_ja = 1;
 * @return {string}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.prototype.getErrorMessageJa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.ErrorMessage.prototype.setErrorMessageJa = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole = {
  OPERATION_ROLE_INVALID: 0,
  OPERATION_ROLE_MANAGE_OPERATOR: 1,
  OPERATION_ROLE_CUSTOMER_SUPPORT: 2,
  OPERATION_ROLE_SERVICE_ADMINISTRATOR: 3
};


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `operatorAcl`.
 * @type {!jspb.ExtensionFieldInfo<!proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl>}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.operatorAcl = new jspb.ExtensionFieldInfo(
    50002,
    {operatorAcl: 0},
    proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.toObject),
    0);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[50002] = new jspb.ExtensionFieldBinaryInfo(
    proto.com.kipp.miraibarai.grpc.ops.v1.operatorAcl,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.serializeBinaryToWriter,
    proto.com.kipp.miraibarai.grpc.ops.v1.OperatorAcl.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[50002] = proto.com.kipp.miraibarai.grpc.ops.v1.operatorAcl;

goog.object.extend(exports, proto.com.kipp.miraibarai.grpc.ops.v1);
